<nav class="navbar" (click)="hideMegaMenu()">
    <div class="navbar-brand">
        <div class="navbar-item">
            <img src="assets/fonts/logo-white.4c6bb62cca44a72ee17c501dfb929105.svg">
        </div>
    </div>
    <div class="navbar-menu">
        <div class="navbar-start" (mouseenter)="onMegaMenuHover()" (mouseleave)="onMegaMenuMouseLeave()">
            <a
                *ngFor="let item of menuLinks; index as idx"
                class="navbar-item"
                (click)="onMenuItemClick(idx, $event)"
                (mouseenter)="onMenuItemHover(idx)"
            >
                {{item.title}}
            </a>
        </div>
        <div class="navbar-end">
            <ng-container *ngIf="(userService.getLoggedUser() | async) as user; else notLogged">

                <div class="navbar-item has-dropdown is-hoverable user-item">
                    <a class="navbar-link is-arrowless">
                        <span class="icon">
                            <img src="assets/fonts/eum-account.9fdc1b9e5485766458e61c6df5d25eef.svg" />
                        </span>
                        <span class="item-title">{{user.userId}}</span>
                    </a>
                    <div class="navbar-dropdown is-right">
                        <ng-container *ngIf="(userService.getLoggedUser() | async) as user; else notLogged">
                            <div class="navbar-item">
                                <span class='profile-label'>User</span><span>{{user.userId}}</span>
                            </div>
                            <div class="navbar-item">
                                <span class='profile-label'>eMail</span><span>{{user.email || 'N/A'}}</span>
                            </div>
                            <hr class="navbar-divider">
                            <a class="navbar-item" [href]="userProfilePageUrl" target="_blank">
                                <span class="icon profile-label">
                                    <i class="mdi mdi-account"></i>
                                </span>
                                <span>My Profile</span>
                            </a>
                            <hr class="navbar-divider">
                            <a class="navbar-item" (click)="onLogoutClick()">
                                <span class="icon profile-label">
                                    <i class="mdi mdi-logout-variant"></i>
                                </span>
                                <span>Log out</span>
                            </a>
                        </ng-container>
                    </div>
                </div>
            </ng-container>
            <ng-template #notLogged>
                <a class="navbar-item user-item" (click)="onLoginClick()">
                    <span class="icon">
                        <img src="assets/fonts/eum-account.9fdc1b9e5485766458e61c6df5d25eef.svg" />
                    </span>
                    <span class="item-title">Log in</span>
                </a>
            </ng-template>
        </div>
    </div>
</nav>
<div class="mega-menu-mask" *ngIf="megaMenuContent" (click)="hideMegaMenu()">
    <div class="mega-menu-overlay" (mouseenter)="onMegaMenuHover()" (mouseleave)="onMegaMenuMouseLeave()" (click)="$event.stopPropagation()">
        <div class="mega-menu">
            <div class="menu-title">{{megaMenuContent.title}}</div>
            <div class="menu-content">
                <div class="menu-section" *ngFor="let section of megaMenuContent.sections">
                    <div class="menu-header">{{section.title}}</div>
                    <a
                        class="menu-entry"
                        *ngFor="let link of section.links"
                        [attr.href]="link.href"
                        target="_blank">
                        {{link.title}}
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// ./src/main/components/navbar/navbar.component.html